/**
 * Shared color constants for the application
 */

/**
 * Default color for trackers when no specific color is provided
 * Matches Tailwind's gray-500 (#6B7280)
 */
export const DEFAULT_TRACKER_COLOR = '#6B7280';
